import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLayoutStore = defineStore('adx-layout', () => {
  // === State ===
  const isNavCollapsed = ref(false)

  // === Actions ===
  const collapseNav = () => {
    isNavCollapsed.value = true
  }

  const expandNav = () => {
    isNavCollapsed.value = false
  }

  const toggleNav = () => {
    isNavCollapsed.value = !isNavCollapsed.value
  }

  return {
    // State
    isNavCollapsed,
    // Actions
    collapseNav,
    expandNav,
    toggleNav
  }
})
